<ng-container class="cards-container">
  @for (goal of goalsList; track goal.title) {
    <goal-card [goal]="goal" [showMoreInfoIcon]="showMoreInfoIcon"></goal-card>
  }
  <h3 *ngIf="showAllToolsHiddenMessage()">
    All tools are hidden. Manage tools visibility by clicking the
    <mat-icon>more_horiz</mat-icon> icon next to the title.
  </h3>
</ng-container>
